import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { isPackingAlertsRole } from "@/constants";

/**
 * True when the logged-in user's IAM role is clinic_ops / clinic_ops_doggyworld
 * (matched by role_id, see PACKING_ALERTS_ROLE_IDS). Drives the packing-alerts
 * navbar pill and the logout-in-sidebar layout.
 */
export const useIsClinicOpsUser = (): boolean => {
  const roleId = useAppSelector((state) => state?.auth?.userPermissions?.role_id);
  return isPackingAlertsRole(roleId);
};
